import CryptoJS from 'crypto-js';

const Decrypt = (id) => {
    let string = decodeURIComponent(id)
    let bytes = CryptoJS.AES.decrypt(string, 'secret key 123');
    let decryptedId = bytes.toString(CryptoJS.enc.Utf8);
    return decryptedId
}
export default Decrypt